var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackgroundWavesMobile = function SvgBackgroundWavesMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 320 30",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 30L320 30L320 2.86102e-05L320 5.08925C310.589 2.46162 300.315 3.9012 291.85 9.40798C280.389 16.8639 265.611 16.8639 254.15 9.40798C242.689 1.95207 227.911 1.95207 216.45 9.40797C204.989 16.8638 190.211 16.8639 178.75 9.40796C167.289 1.95206 152.511 1.95206 141.05 9.40795C129.589 16.8639 114.811 16.8639 103.35 9.40795C91.8892 1.95208 77.1107 1.95204 65.6499 9.40794C54.1891 16.8638 39.4106 16.8638 27.9499 9.40794C19.5452 3.94021 9.35623 2.48219 2.1826e-06 5.03392L0 30Z"
  })));
};
export default SvgBackgroundWavesMobile;